import { Link } from 'react-router-dom'
import { Instagram, Phone, MapPin, Mail } from 'lucide-react'
import { LOGO_URL } from '@/lib/constants'
import { useSiteSettings } from '@/hooks/use-site-settings'

export function Footer() {
  const { settings } = useSiteSettings()
  const logoUrl = settings?.logo_url || LOGO_URL

  return (
    <footer className="bg-accent/30 pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-1 md:col-span-1">
            <div className="mb-4">
              <img
                src={logoUrl}
                alt={settings?.company_name || 'Viveiro Floresta Logo'}
                className="h-12 w-auto"
              />
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              {settings?.company_name || 'Floresta Paisagismo'}. Transformando
              espaços em refúgios naturais.
            </p>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-foreground">Navegação</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/" className="hover:text-primary">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/planos" className="hover:text-primary">
                  Planos e Preços
                </Link>
              </li>
              <li>
                <Link to="/projetos" className="hover:text-primary">
                  Projetos Reais
                </Link>
              </li>
              <li>
                <Link to="/area-cliente" className="hover:text-primary">
                  Área do Cliente
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-foreground">Contato</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <Phone className="h-4 w-4 mt-0.5 shrink-0" />
                <span>{settings?.contact_phone || '(64) 98453-6263'}</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="h-4 w-4 mt-0.5 shrink-0" />
                <span>
                  {settings?.contact_email || 'viveirofloresta@hotmail.com'}
                </span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 shrink-0" />
                <span>
                  {settings?.address || 'Rua Amapá, 539, Centro, Goiatuba, GO'}
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-foreground">Redes Sociais</h4>
            <div className="flex gap-4">
              <a
                href={
                  settings?.instagram_link ||
                  'https://instagram.com/viveirofloresta'
                }
                target="_blank"
                rel="noreferrer"
                className="p-2 bg-white rounded-full shadow-sm hover:shadow-md hover:text-pink-600 transition-all"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-8 text-center text-xs text-muted-foreground">
          <p>
            &copy; {new Date().getFullYear()}{' '}
            {settings?.company_name || 'Floresta Paisagismo'}. Todos os direitos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  )
}
